import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-designerportfolio',
  templateUrl: './view-designerportfolio.component.html',
  styleUrls: ['./view-designerportfolio.component.css']
})
export class ViewDesignerportfolioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/platform/organisation/designer_portfolio/view-designerportfolio/view-designerportfolio.component.ts